export const investmentStrategies = [
  {
    id: 1,
    title: 'Value Investing Fundamentals',
    category: 'Stock Market',
    difficulty: 'Beginner',
    timeframe: 'Long-term (5+ years)',
    description: 'Learn to identify undervalued companies with strong fundamentals and hold for long-term appreciation.',
    keyPrinciples: [
      'Analyze financial statements and ratios',
      'Look for companies trading below intrinsic value',
      'Focus on competitive advantages and moats',
      'Practice patience and discipline',
    ],
    expectedReturn: '8-12% annually',
  },
  {
    id: 2,
    title: 'Growth Stock Selection',
    category: 'Stock Market',
    difficulty: 'Intermediate',
    timeframe: 'Medium-term (2-5 years)',
    description: 'Identify high-growth companies in emerging sectors with strong revenue and earnings momentum.',
    keyPrinciples: [
      'Focus on revenue growth rates above 20%',
      'Analyze market trends and sector dynamics',
      'Evaluate management team and execution',
      'Monitor competitive positioning',
    ],
    expectedReturn: '15-25% annually',
  },
  {
    id: 3,
    title: 'Dividend Aristocrat Strategy',
    category: 'Income',
    difficulty: 'Beginner',
    timeframe: 'Long-term (10+ years)',
    description: 'Build a portfolio of companies with 25+ years of consecutive dividend increases for reliable income.',
    keyPrinciples: [
      'Select companies with strong dividend history',
      'Reinvest dividends for compound growth',
      'Diversify across sectors',
      'Monitor payout ratios and sustainability',
    ],
    expectedReturn: '6-10% annually + dividends',
  },
  {
    id: 4,
    title: 'Index Fund Allocation',
    category: 'Passive',
    difficulty: 'Beginner',
    timeframe: 'Long-term (10+ years)',
    description: 'Low-cost, diversified approach using broad market index funds for consistent returns.',
    keyPrinciples: [
      'Invest in S&P 500 and total market funds',
      'Maintain consistent monthly contributions',
      'Rebalance annually',
      'Minimize fees and taxes',
    ],
    expectedReturn: '7-10% annually',
  },
  {
    id: 5,
    title: 'Real Estate Investment Trusts',
    category: 'Real Estate',
    difficulty: 'Intermediate',
    timeframe: 'Medium-term (3-7 years)',
    description: 'Gain real estate exposure through publicly traded REITs for income and appreciation.',
    keyPrinciples: [
      'Diversify across property types',
      'Analyze occupancy rates and rental income',
      'Consider geographic diversification',
      'Monitor interest rate environment',
    ],
    expectedReturn: '8-14% annually + distributions',
  },
  {
    id: 6,
    title: 'Options Income Strategies',
    category: 'Advanced',
    difficulty: 'Advanced',
    timeframe: 'Short-term (weeks to months)',
    description: 'Generate income through covered calls and cash-secured puts on quality stocks.',
    keyPrinciples: [
      'Sell options on stocks you own or want to own',
      'Focus on high-quality underlying assets',
      'Manage risk with position sizing',
      'Understand assignment and exercise mechanics',
    ],
    expectedReturn: '10-20% annually',
  },
];

export const maStrategies = [
  {
    id: 1,
    title: 'Small Business Acquisition',
    type: 'Acquisition',
    capitalRequired: '$100K - $500K',
    description: 'Acquire profitable small businesses with established customer bases and cash flow.',
    steps: [
      'Identify target industries and markets',
      'Conduct thorough due diligence',
      'Negotiate favorable terms and financing',
      'Implement operational improvements',
      'Scale or exit within 3-5 years',
    ],
  },
  {
    id: 2,
    title: 'Roll-up Strategy',
    type: 'Consolidation',
    capitalRequired: '$1M - $10M',
    description: 'Consolidate fragmented industries by acquiring multiple small competitors.',
    steps: [
      'Select fragmented industry with consolidation opportunity',
      'Acquire platform company as foundation',
      'Execute add-on acquisitions',
      'Realize synergies and economies of scale',
      'Exit to strategic buyer or private equity',
    ],
  },
  {
    id: 3,
    title: 'Distressed Asset Turnaround',
    type: 'Turnaround',
    capitalRequired: '$250K - $2M',
    description: 'Purchase underperforming businesses at discount and implement turnaround strategies.',
    steps: [
      'Identify distressed but viable businesses',
      'Analyze root causes of underperformance',
      'Negotiate favorable purchase terms',
      'Execute rapid operational improvements',
      'Stabilize and grow for exit',
    ],
  },
];